import { render, staticRenderFns } from "./SettingsDropdown.vue?vue&type=template&id=67e98e9c&scoped=true"
import script from "./SettingsDropdown.vue?vue&type=script&lang=js"
export * from "./SettingsDropdown.vue?vue&type=script&lang=js"
import style0 from "./SettingsDropdown.vue?vue&type=style&index=0&id=67e98e9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e98e9c",
  null
  
)

export default component.exports